import api from '../../../utils/api'

export const getSessionsAdminApi = (data) => api.get('/admin/sessions', { params: data })
export const updateSessionsAdminApi = (data) => api.post('/admin/sessions', data)
export const deleteSessionAdminApi = (id) => api.delete(`/admin/sessions/${id}`)
export const bookByAdminApi = (id, data) => api.put(`/admin/sessions/${id}`, data)
export const createPatientByAdminApi = (data) => api.post('/admin/patients', data)
export const updatePatientByAdminApi = (id, data) => api.put(`/admin/transactions/${id}`, data)
export const getResultsApi = (patientId) => api.get(`admin/upload_results/${patientId}`, { responseType: 'blob' })
